const Footer = () => {
    return(
        <footer>
            <p>v O.1</p>
            <p>by Jordan Sinou</p>
        </footer>
    )
}

export default Footer